import { QueryParamConfig } from "serialize-query-params/esm/types";

export function enumParams<T, ET = T>(config: QueryParamConfig<any, any>, enumValues: ET[]): QueryParamConfig<T, T> {
  const enumValuesSet = new Set(enumValues);

  return {
    encode: config.encode,
    equals: config.equals,
    decode: (value: any) => {
      const decodedValue = config.decode(value);
      if (decodedValue && Array.isArray(decodedValue)) {
        const validValues = decodedValue.filter((item: any) => !(item in enumValuesSet));
        return validValues.length > 0 ? validValues : null;
      }
      return enumValuesSet.has(decodedValue) ? decodedValue : null;
    },
  };
}
